import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ReactSVG } from "react-svg"

import { getAuthMessage } from "../../../../../redux/action/auth/authAction"

const AuthMessageToUsers = () => {

    const dispatch = useDispatch()
    const textAlarmToUser = useSelector((state) => state.auth.textAlarm)

    useEffect(() => {
    
        if( !textAlarmToUser )
            getInfo()

    }, [])

    const getInfo = async () => {
        await dispatch( await getAuthMessage() )
    }

    if(!textAlarmToUser){

        return (
            <>
            </>
        )
    
    }
    
    return (
        <>
            <div className="bg-red-100 mb-12 border-red-500 rounded-xl p-3 flex items-center gap-2 w-full">

                <ReactSVG 
                    className="w-5 text-red-500 -scale-x-100"
                    src={`${process.env.PUBLIC_URL}/assets/images/icons/megaphone.svg`}
                />

                <span>
                    
                    { textAlarmToUser }

                </span>

            </div>  
        </>
    )
}

export default AuthMessageToUsers